export default class InfoOverlay {
  constructor($el) {
    this.$el = $el;
  }

  init() {
    this.$main = document.querySelector('main');

    document.addEventListener('click', (event) => {
      if (event.target.hasAttribute('data-hide-info-overlay-detail')) {
        const detailID = event.target.dataset.hideInfoOverlayDetail;

        if (detailID) {
          this.hideOverlay(detailID);
        } else {
          this.hideAllOverlays();
        }
      }

      if (event.target.hasAttribute('data-open-info-overlay-detail')) {
        const detailID = event.target.dataset.openInfoOverlayDetail;

        this.showOverlay(detailID);
      }

      if (event.target.parentNode.hasAttribute('data-info-overlay-detail')) {
        this.hideVisibleOverlay();
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.hideVisibleOverlay();
      }
    });

    this.hideAlreadyClosedOverlays();
  }

  showOverlay(id) {
    const $overlay = document.querySelector(`[data-info-overlay-detail="${id}"]`);

    if ($overlay) {
      $overlay.classList.add('-visible');

      document.documentElement.classList.add('_overflow-hidden');
      this.$main.classList.add('_z-force-high');

      const event = new Event('refreshImageSliders', { bubbles: true }); // (2)
      document.dispatchEvent(event);
    }
  }

  hideVisibleOverlay() {
    const visibleOverlayId = document.querySelector('[data-info-overlay-detail].-visible').dataset.infoOverlayDetail;

    if (visibleOverlayId) {
      this.hideOverlay(visibleOverlayId);
    }
  }

  hideOverlay(id) {
    const $overlay = document.querySelector(`[data-info-overlay-detail="${id}"]`);

    if ($overlay) {
      $overlay.classList.remove('-visible');

      document.documentElement.classList.remove('_overflow-hidden');
      this.$main.classList.remove('_z-force-high');

      if ($overlay.dataset.infoOverlayDetailSaveAsClosed) {
        this.saveAsClosed(id);
      }

      this.stopVideo($overlay);
    }
  }

  hideAllOverlays() {
    const $overlays = [...document.querySelectorAll('[data-info-overlay-detail].-visible')];

    $overlays.forEach(($overlay) => {
      const overlayId = $overlay.dataset.infoOverlayDetail;

      this.hideOverlay(overlayId);
    });

    return this;
  }

  hideAlreadyClosedOverlays() {
    const $overlays = [...document.querySelectorAll('[data-info-overlay-detail].-visible')];

    $overlays.forEach(($overlay) => {
      const overlayId = $overlay.dataset.infoOverlayDetail;

      if (sessionStorage.getItem(`closed-${overlayId}`)) {
        this.hideOverlay(overlayId);
      }
    });

    return this;
  }

  saveAsClosed(id) {
    sessionStorage.setItem(`closed-${id}`, true);

    return this;
  }

  // stop video when modal is closed (Video.Slider Module)
  // https://forum.freecodecamp.org/t/youtube-video-in-modal-cant-stop-sound-after-closing/175726
  /* eslint-disable class-methods-use-this */
  stopVideo(overlay) {
    const iframe = overlay.querySelector('iframe');
    if (iframe) {
      const iframeSrc = iframe.src;
      if (iframeSrc) {
        const updatedSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
        iframe.src = updatedSrc;
      }
    }
  }
}
